// Qué término sirve para la búsqueda exacta de clientes del silo (`GET /customers/search`). Puro.

/** Un teléfono MX de 10 dígitos. Es una de las dos formas que el buscador exacto del silo entiende. */
function isSearchablePhone(term: string): boolean {
    return /^\d{10}$/.test(term.replace(/[\s-]/g, ''));
}

/** Una CURP completa — la otra forma que el buscador exacto entiende. */
export function isSearchableCurp(term: string): boolean {
    return /^[A-Z]{4}\d{6}[A-Z]{6}[A-Z\d]{2}$/i.test(term.trim());
}

/** Solo teléfono o CURP completos: con cualquier otra cosa el silo devolvería `[]` y gastaría un request. */
export function isExactSearchTerm(term: string): boolean {
    return isSearchablePhone(term) || isSearchableCurp(term);
}
